import {
	BooleanEntityAttribute,
	DateEntityAttribute,
	Entity,
	IntegerEntityAttribute,
	StringEntityAttribute
} from '../base/Entity';

/**
 * @name User
 * @property {Number} Id
 * @property {Date} CreationDate
 *
 * @property {String} Name
 * @property {String} Email
 * @property {String} FacebookId
 *
 * @property {String} RTUser
 * @property {Boolean} RTSponsor
 * @property {Number} RTLastValidation
 * @property {String} RTValidationCode
 *
 * @property {Boolean} IsDonor
 * @property {Date} SubscriptionEnd
 *
 * @property {Boolean} IsAdmin
 *
 * @property {String} AvatarUrl
 * @property {Number} Status
 */
export class User extends Entity {
}

User.Register('User');
User.Attributes = [
	new IntegerEntityAttribute('Id'),
	new DateEntityAttribute('CreationDate'),

	new StringEntityAttribute('Name'),
	new StringEntityAttribute('Email'),
	new StringEntityAttribute('FacebookId'),

	new StringEntityAttribute('RTUser'),
	new BooleanEntityAttribute('RTSponsor'),
	new IntegerEntityAttribute('RTLastValidation'),
	new StringEntityAttribute('RTValidationCode'),

	new BooleanEntityAttribute('IsDonor'),
	new DateEntityAttribute('SubscriptionEnd'),

	new BooleanEntityAttribute('IsAdmin'),

	new StringEntityAttribute('AvatarUrl'),
	new IntegerEntityAttribute('Status')
];

export default User;
